<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="toc" id="toc">
<h1 class="ctfm"><a class="page" id="pviii"></a><a class="page" id="pix"></a>CONTENTS</h1>
<p class="tocfm" id="rintro1"><a class="xref" href="#/nyuskousen0008#intro1">Introduction to the New Revised Edition: GO beyond GDP</a></p>
<p class="tocfm" id="rintro2"><a class="xref" href="#/nyuskousen0009#intro2">Introduction to the Previous Edition</a></p>
<p class="toc1" id="rpref"><a class="xref" href="#/nyuskousen0010#pref">Preface</a></p>
<p class="tocf" id="rch01"><a class="xref" href="#/nyuskousen0011#ch01">1. Introduction: The Case for a New Macroeconomics</a></p>
<p class="tocpt" id="rpt01"><a class="xref" href="#/nyuskousen0012#pt01">PART 1</a></p>
<p class="tocpt"><a class="xref" href="#/nyuskousen0012#pt01">THE STRUCTURE OF PRODUCTION: A HISTORICAL SURVEY</a></p>
<p class="toc" id="rch02"><a class="xref" href="#/nyuskousen0013#ch02">2. The Theory of Production in Classical Economics</a></p>
<p class="toc" id="rch03"><a class="xref" href="#/nyuskousen0014#ch03">3. Hayek and the 1930s: A New Vision of Macroeconomics</a></p>
<p class="toc" id="rch04"><a class="xref" href="#/nyuskousen0015#ch04">4. Time and Production in the Post-Keynesian Era</a></p>
<p class="tocpt" id="rpt02"><a class="xref" href="#/nyuskousen0016#pt02">PART 2</a></p>
<p class="tocpt"><a class="xref" href="#/nyuskousen0016#pt02">THE THEORETICAL FRAMEWORK</a></p>
<p class="toc" id="rch05"><a class="xref" href="#/nyuskousen0017#ch05">5. The Structure of Production: The Building Blocks</a></p>
<p class="toc" id="rch06"><a class="xref" href="#/nyuskousen0019#ch06">6. Time and the Aggregate Production Structure</a></p>
<p class="toc" id="rch07"><a class="xref" href="#/nyuskousen0020#ch07">7. Savings, Technology, and Economic Growth</a></p>
<p class="toc" id="rch08"><a class="xref" href="#/nyuskousen0021#ch08">8. The Theory of Commodity Money: Economics of a Pure Gold Standard</a></p>
<p class="toc" id="rch09"><a class="xref" href="#/nyuskousen0022#ch09">9. Economics of a Fiat Money Standard: A Theory of the Business Cycle</a></p>
<p class="tocpt" id="rpt03"><a class="page" id="px"></a><a class="xref" href="#/nyuskousen0023#pt03">PART 3</a></p>
<p class="tocpt"><a class="xref" href="#/nyuskousen0023#pt03">APPLICATIONS</a></p>
<p class="toc" id="rch10"><a class="xref" href="#/nyuskousen0024#ch10">10. Implications for Government Economic Policy</a></p>
<p class="toc" id="rch11"><a class="xref" href="#/nyuskousen0025#ch11">11. Conclusions: The Future of Economic Theory and Research</a></p>
<p class="tocbmf" id="rrefs"><a class="xref" href="#/nyuskousen0026#refs">References</a></p>
<p class="tocbm" id="rindex"><a class="xref" href="#/nyuskousen0027#index">Index</a></p>
<p class="tocbm" id="raubio"><a class="xref" href="#/nyuskousen0028#aubio">About the Author</a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nyu-skousen-0007.vue?caabca34